import { queries } from 'apollo';
import * as React from 'react';
import { Query, QueryResult } from 'react-apollo';
import { Subtract } from 'utility-types';

export interface INewsItemResult {
  _meta: {
    id: string;
  };
  Featured: string;
  Title: string;
  Author: string;
  NewsItemImage?: {
    src: string;
  };
  Content: string;
}

export interface ISocialResult {
  ShowInsta: string | null;
  ShowFacebook: string | null;
  FacebookHTML: string | null;
  InstaHTML: string | null;
}

interface IHomePageDataResult {
  fetch: {
    Common: {
      Registration: {
        Active: string | null;
      } | null;
      News: {
        BackgroundColor: string | null;
      } | null;
      Logos: {
        BackgroundColor: string | null;
      } | null;
      Numbers: {
        BackgroundColor: string | null;
      } | null;
      SocialFeed: {
        BackgroundColor: string | null;
      } | null;
      Sponsors: {
        BackgroundColor: string | null;
      } | null;
      Video: {
        BackgroundColor: string | null;
        BackgroundImage: {
          src: string;
        } | null;
      } | null;
    };
    Global: {
      HomePage: {
        NewsSection: {
          News: INewsItemResult[] | null;
          FeaturedNews: INewsItemResult | null;
        } | null;
      };
    };
    Country: {
      Name: string;
      RegistrationPage: {
        ShowRegistrationButton: string | null;
        ShowSplashRegistrationButton: string | null;
      } | null;
      HomePage: {
        NewsSection: {
          ReadMore: string | null;
          ShowNews: string | null;
          News: INewsItemResult[] | null;
          FeaturedNews: INewsItemResult | null;
          FeaturedArticleText: string;
          LatestNews: string | null;
        } | null;
        Banners: Array<{
          Name: string | null;
          Subtitle: string | null;
          ButtonText: string | null;
          ButtonLink: string | null;
          BannerImage: {
            src: string;
          } | null;
        }> | null;
        SponsorLogos: {
          ShowSponsors: string | null;
          SponsorImages: Array<{
            SponsorImage: {
              src: string;
            };
          }>;
        } | null;
        SplashSection: {
          HomeSplashImage: {
            src: string;
          } | null;
          SplashText: string;
          SplashButtonLink: string | null;
          ButtonText: string | null;
          Countdown: {
            DaysText: string | null;
            HoursText: string | null;
            MinutesText: string | null;
            SecondsText: string | null;
            CountdownText: string | null;
            CountdownDate: string | null;
          } | null;
        } | null;
        Numbers: {
          VariableLabels: {
            CompetingCountriesText: string;
            QualifyingEventsText: string;
            PlayersParticipatingText: string;
          } | null;
          VariableText: {
            CompetingCountriesCount: string;
            QualifyingEventsCount: string;
            PlayersParticipatingCount: string;
          } | null;
        } | null;
        WorldFinalsConfig: {
          DescriptionImage: {
            src: string;
          } | null;
          ButtonLink: string | null;
          Description: string;
          DescriptionButtonText: string;
        } | null;
        HomeVideo: {
          HomeVideo: string | null;
        } | null;
        SocialMedia: ISocialResult | null;
      };
    };
  };
}

interface IRequiredProps {
  country: string;
}

interface IVariables {
  filters: {
    UrlKey: string;
  };
}

export type WithHomePageQueryProps = QueryResult<IHomePageDataResult>;

class HomePageQuery extends Query<IHomePageDataResult, IVariables> {}

const withHomePageQuery = <P extends WithHomePageQueryProps>(
  Component: React.ComponentType<P>
): React.SFC<Subtract<P, WithHomePageQueryProps> & IRequiredProps> => props => {
  const { country } = props;
  return (
    <HomePageQuery
      query={queries.GET_HOME_PAGE_DATA}
      variables={{
        filters: { UrlKey: country }
      }}
    >
      {providedProps => <Component {...providedProps} {...props as any} />}
    </HomePageQuery>
  );
};

export default withHomePageQuery;



// WEBPACK FOOTER //
// ./src/enhancers/withHomePageQuery.tsx